// TokenChecker.js
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { isTokenExpired } from "../utility/authUtility";

const TokenChecker = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const token = localStorage.getItem("token");
    const publicPaths = [
      "/signin",
      "/signup",
      "/forgot-password",
      "/unverified",
    ];
    if (publicPaths.includes(location.pathname)) return;
    if (!token || isTokenExpired(token)) {
      console.warn("Token expired. Logging out...");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      navigate("/signin");
    }
  }, [location.pathname]);

  return null; // nothing to render
};

export default TokenChecker;
